module.exports = __webpack_public_path__ + "Roboto-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Bold.woff2
// module id = 90
// module chunks = 0